export default "__VITE_ASSET__5fcf8684__"